export class SelectProductOption {
    constructor(optionalOptions = {}) {
        this._optionsListWrap = document.querySelectorAll('.sheet-column [data-type="select-product-option"]');

        if (!this._optionsListWrap) {
            this.destructor();
            return true;
        }

        const removeSelectedMarker = (thatList) => {
            if (thatList.querySelector('li.selected')) {
                thatList.querySelector('li.selected').classList.remove('selected');
            }
        }

        let targetInput;
        let targetText;

        this._optionsListWrap.forEach((oneList) => {
            this._optionOne = oneList.querySelectorAll('li')
            if (!this._optionOne) {
                this.destructor();
                return true;
            }

            targetInput = oneList.closest('.sheet-body').dataset.inputTarget
            targetText = oneList.closest('.sheet-body').dataset.textTarget

            this._optionOne.forEach((one) => {
                one.addEventListener("click", () => {

                    if (one.classList.contains('selected')) {
                        return false
                    }

                    removeSelectedMarker(oneList)
                    one.classList.add('selected')

                    if (targetInput) {
                        targetInput = document.querySelector(targetInput);
                        if (!targetInput) {
                            return false
                        }

                        targetInput.val = one.dataset.value
                    }

                    if (targetText) {
                        targetText = document.querySelector(targetText);
                        if (!targetText) {
                            return false
                        }

                        targetText.classList.add('selected')
                        targetText.innerText = one.dataset.display
                    }

                    document.querySelector('.sheet-overlay').click()
                })
            })
        })
    }

    destructor() {
        this._optionsListWrap = null;
        this._optionOne = null;
    }
}

export default new SelectProductOption();
